import type { BoxProps } from '@packages/shared';
import { Box } from '@packages/shared';
import type { StepIconProps, Theme } from '@mui/material';
import type { SxProps } from '@mui/system';
import { Checkmark32 } from '@packages/themes/icons';
import { iconSize } from '../config';

const dotSize = `${iconSize}rem`;
const activeDotSize = `${(iconSize * 3) / 4}rem`;
const inactiveDotSize = `${iconSize / 2}rem`;

export type SampleOrderStepperIconProps = Pick<StepIconProps, 'completed' | 'active'> &
  Omit<BoxProps, 'sx'> & {
    isFinished: boolean;
    sx?: SxProps<Theme>;
  };

export const Icon = ({
  completed,
  active,
  isFinished,
  sx,
  ...rest
}: SampleOrderStepperIconProps) => (
  <Box
    {...rest}
    sx={{
      ...sx,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: dotSize,
      height: dotSize,
      p: 0,
    }}
  >
    <Box
      sx={{
        width: { xs: dotSize, md: active ? activeDotSize : inactiveDotSize },
        height: { xs: dotSize, md: active ? activeDotSize : inactiveDotSize },
        borderRadius: '50%',
        backgroundColor: completed || active ? 'primary.main' : 'grey.main',

        ...(isFinished && {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }),
      }}
    >
      {isFinished && (
        <Checkmark32 sx={{ color: 'common.white', width: '0.563rem', height: '0.563rem' }} />
      )}
    </Box>
  </Box>
);
